import { ArrowRight, Clock } from "lucide-react";
import { Link } from "react-router-dom";

import { AuthShell } from "@/widgets/AuthShell";

export function RegisterPendingPage(): JSX.Element {
  return (
    <AuthShell glow="amber">
      <div className="glass-card p-10 text-center">
        <div className="relative mx-auto mb-6 flex h-24 w-24 items-center justify-center">
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(245,158,11,0.30), transparent 65%)",
              filter: "blur(10px)",
            }}
          />
          <div className="relative flex h-[72px] w-[72px] items-center justify-center rounded-2xl bg-gradient-to-br from-amber to-amber-dark text-white shadow-glow-amber">
            <Clock className="h-9 w-9" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-white">Заявка отправлена</h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground/90">
          Ваш аккаунт создан, но требует ручного подтверждения. Обычно проверка занимает несколько часов.
          После подтверждения вы сможете войти в свой кабинет.
        </p>

        <div className="mt-6 rounded-xl border border-amber/25 bg-amber/[0.07] p-4 text-left text-sm leading-snug text-foreground/90">
          <div className="mb-1 flex items-center gap-2 font-semibold text-amber">
            <Clock className="h-3.5 w-3.5" />
            Обычно несколько часов
          </div>
          Если вы прошли курс — напишите автору в Telegram и пришлите email,
          под которым регистрировались.
        </div>

        <Link
          to="/login"
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/15 bg-white/[0.04] px-5 py-3 text-sm font-semibold text-white transition hover:bg-white/[0.08]"
        >
          На страницу входа <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </AuthShell>
  );
}
